module.exports = __webpack_public_path__ + "img/asan5.0b7da791.png";